


































import { defineComponent, reactive, toRefs, computed, watch, PropType, onMounted, onBeforeUnmount, nextTick } from '@vue/composition-api';
import { MovieContent, StudentMovieContent } from "../modules/student/DigitalReport"
import http from "../plugins/http";
import "../plugins/smart_stream/js/oneTagPlayer";
import "../plugins/smart_stream/css/oneTagPlaye.css";

declare global {
  interface Window {
    CreateVideoPlayer: any;
    DestroyVideoPlayer: any;
  }
}

export interface Data {
  selectedMovieIdx: number
  playerError: string
}

export default defineComponent({
  props: {
    movieContents: {
      type: Array as PropType<MovieContent[]>,
      required: true
    },
    height: {
      type: Number as PropType<number>,
      required: true
    },
    direction: {
      type: Number as PropType<number>,
      required: true
    },
    sheet_type: {
      type: Number as PropType<number>,
      required: true
    },
    title: {
      type: String as PropType<string>,
      default: "動画視聴"
    },
    imageType: {
      type: String as PropType<string>,
      default: "movie"
    },
    previewImageType: {
      type: Number as PropType<number>,
      required: true
    },
    baseSheetId: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup (props, context) {
    const state = reactive<Data>({
      selectedMovieIdx: 0,
      playerError: null,
    });

    const areaHeightStyle = computed((): any => {
      const style: any = {};
      style["height"] = `${props.height - 48}px`;
      return style;
    });

    const selectedMovieContent = computed((): MovieContent | null => {
      if(props.movieContents.length == 0){
        return null;
      }
      return props.movieContents[state.selectedMovieIdx] || null;
    });

    const selectedMovieTitle = computed((): string => {
      if(!selectedMovieContent.value){
        return "動画未登録";
      }
      return selectedMovieContent.value.original_filename || `動画 ${state.selectedMovieIdx + 1}`;
    });

    const playerTargetId = computed((): string => {
      return `movie-player-${props.direction}-${props.sheet_type}`;
    });

    const embedPlayer = async () => {
      if(!selectedMovieContent.value){
        return;
      }

      if(!window.CreateVideoPlayer){
        state.playerError = "動画プレイヤーの初期化に失敗しました。";
        return;
      }

      try{
        state.playerError = null;

        const movieContent = selectedMovieContent.value;
        if(!movieContent){
          throw new Error("動画情報が取得できません。");
        }

        const response = await http.get(`/api/movie_content/movie_url/${props.baseSheetId}/${movieContent.id}`);

        if(!response.data.movie_url){
          throw new Error("動画視聴URLの取得に失敗しました。");
        }

        const movieUrl = response.data.movie_url;
        const movieid = response.data.movieid;
        const time = response.data.time;

        await nextTick();

        clearPlayer();

        const target = document.getElementById(playerTargetId.value);
        if(!target){
          return;
        }
        context.root.$nextTick(async () => {
          window.CreateVideoPlayer({
            target: playerTargetId.value,
            src: movieUrl,
            auto: "off",
            time: time,
            movieid: movieid,
          });
        });
        
      // @ts-ignore
      }catch(error: any){
        if(error.response?.status == 422){
          state.playerError = error.response.data.errors?.[0] || "動画視聴URLの取得に失敗しました。";
        }else if(error.message){
          state.playerError = error.message;
        }else{
          state.playerError = "予期せぬ例外が発生しました。";
        }
      }
    }

    const clearPlayer = () => {
      if(window.DestroyVideoPlayer){
        window.DestroyVideoPlayer(playerTargetId.value);
      }
      const target = document.getElementById(playerTargetId.value);
      if(!target){
        return;
      }
      const videoElem = target.querySelector("video") as HTMLVideoElement;
      if(videoElem){
        videoElem.pause();
      }
      target.innerHTML = "";
    }

    const pageChanged = (idx: number) => {
      if(idx < 0 || idx + 1 > props.movieContents.length){
        return;
      }
      state.selectedMovieIdx = idx;
    }

    const changeImageType = (imageType: number) => {
      context.emit("change-image-type", imageType);
    }

    watch(() => props.movieContents, () => {
      if(state.selectedMovieIdx + 1 > props.movieContents.length){
        state.selectedMovieIdx = 0;
      }
    });

    watch(() => state.selectedMovieIdx, async () => {
      await embedPlayer();
    });

    onMounted(async () => {
      await embedPlayer();
    });

    onBeforeUnmount(() => {
      clearPlayer();
    });

    return {
      ...toRefs(state),
      areaHeightStyle,
      selectedMovieTitle,
      playerTargetId,
      pageChanged,
      changeImageType,
    }
  }
});
